import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { FileDown } from "lucide-react";

export default function PoukazkyReportPage() {
  const { user } = useAuth();   // ← uživatel z contextu
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.pharmacyCode) return;

    const firma = user.firma || "LEMON";

    (async () => {
      try {
        const res = await fetch(
          `/api/poukazky-report/${firma}/${user.pharmacyCode}/report`
        );
        if (!res.ok) throw new Error("Chyba při načítání reportu");
        const blob = await res.blob();
        setPdfUrl(URL.createObjectURL(blob));
      } catch (err) {
        console.error("Report error:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-xl font-semibold flex items-center gap-2">
        <FileDown className="w-6 h-6" /> Report poukázek
      </h1>

      {loading && <p>Načítám data…</p>}

      {!loading && !pdfUrl && (
        <p className="text-red-600">Report není k dispozici.</p>
      )}

      {pdfUrl && (
        <>
          <iframe
            src={pdfUrl}
            title="Report"
            className="w-full h-[600px] border rounded"
          />

          <a
            href={pdfUrl}
            download="poukazky-report.pdf"
            className="inline-block mt-4 px-4 py-2 bg-green-700 hover:bg-green-800 text-white rounded"
          >
            Stáhnout jako PDF
          </a>
        </>
      )}
    </div>
  );
}
